// 密码格式长度
export const MIN_PASSWORD_LEN = 4;
export const MAX_PASSWORD_LEN = 14;

export type IVerifyType = 'emailLogin' | 'register';
export type IRegisterInfoType = {
  reason: string;
  group_name: string;
  email: string;
  password: string;
  // 注册页面获取验证码
  isRegister: boolean;
  // 用户岗位
  occupation?: string;
}
export interface EmailLoginCodeType {
  login14Days?: boolean;
  verifyType: IVerifyType;
  registerInfo: IRegisterInfoType | null;
  expires: number;
  valueEmail: string;
  valuePadssword: string;
  onLoginSuccess: () => void;
  onBack: () => void;
  onError: (msg: string, code?: number) => void;
}

export interface FetchSSOInfoResultType {
  authentications: [FetchSSOInfoItemType];
}

export interface FetchSSOInfoItemType {
  id: string;
  group?: string;
  icon?: string;
  identity_provider: string;
  client_id: string;
  login_domain: string;
}

export interface idpOptionsItemType {
  text: React.JSX.Element; 
  value: string; 
  company?: string | undefined;
}

export interface SSOLoginCodeType {
  id: string;
  group?: string;
  icon?: string;
  identityProvider?: string;
  clientId?: string;
  loginDomain?: string;
}

export interface SSOInfoType {
  googleInfo: FetchSSOInfoItemType | null;
  IdpList: Array<idpOptionsItemType> | null;
  historySSOInfo: FetchSSOInfoItemType | null;
}